import loadable from "@loadable/component"

import useCollection from "areas/collection/hoc/use-collection"
import { retry } from "helpers/application"

import Description from "./heading/description"

const DescriptionMarkdown = loadable(() =>
  retry(() => import("./description-markdown"))
)

const CollectionDescription = () => {
  const { data: { description, description_type: descriptionType } = {} } =
    useCollection()

  if (!description) return ""

  return (
    <div className="bg-subpolar text-neutral py-24">
      <div className="contained px-16">
        <div className="mb-24">
          <Description />
        </div>
        {["markdown", "spreadsheet"].includes(descriptionType) ? (
          <DescriptionMarkdown classNames={{ paragraphClassName: "mb-16" }}>
            {description}
          </DescriptionMarkdown>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        )}
      </div>
    </div>
  )
}

export default CollectionDescription
